import countries from './Countries_all';
const stepFields = [
	{
		label: 'Payment method',
		display: 'Payment method',
		id: 'paymentMethod',
		name: 'paymentMethod',
		placeholder: '',
		type: 'radio',
		values: [
			{
				className: 'Payment--paypal',
				value: 'payPal',
				label: 'Paypal'
			},
			{
				className: 'Payment--bankTransfer',
				value: 'bankTransfer',
				label: 'Bank transfer'
			}
		],
		rules: 'required',
		onClick: function() {
			let inputs = document.getElementsByName('paymentMethod');
			let selected;
			let paypalInputs = document.querySelectorAll('.Input--paypal');
			let bankTransferInputs = document.querySelectorAll('.Input--bankTransfer');
			inputs = Array.from(inputs);
			paypalInputs = Array.from(paypalInputs);
			bankTransferInputs = Array.from(bankTransferInputs);
			inputs.forEach((value) => {
				if(value.checked === true) {
					return selected = value.value;
				}
			});
			if(selected === 'payPal') {
				paypalInputs.forEach((input) => {
					input.classList.remove('hidden-xs-up');
				});
				bankTransferInputs.forEach((input) => {
					input.classList.add('hidden-xs-up');
				});
			}
			if(selected === 'bankTransfer') {
				bankTransferInputs.forEach((input) => {
					input.classList.remove('hidden-xs-up');
				});
				paypalInputs.forEach((input) => {
					input.classList.add('hidden-xs-up');
				});
			}
		},
		className: 'Input--labelOut Input--labelCentered'
	},
	{
		label: 'PayPal e-mail',
		display: 'PayPal e-mail',
		id: 'payPalEmail',
		name: 'payPalEmail',
		placeholder: '...',
		type: 'text',
		rules: 'required|valid_email',
		depends: function(field) {
			return document.getElementById('payPal').checked ? true : false;
		},
		className: 'hidden-xs-up Input--paypal'
	},
	{
		label: 'PayPal e-mail confirmation',
		display: 'PayPal e-mail confirmation',
		id: 'payPalEmailConfirm',
		name: 'payPalEmailConfirm',
		placeholder: '...',
		type: 'text',
		rules: 'required|valid_email|matches[payPalEmail]',
		depends: function(field) {
			return document.getElementById('payPal').checked ? true : false;
		},
		className: 'hidden-xs-up Input--paypal'
	},
	{
		label: 'IBAN',
		display: 'IBAN',
		id: 'IBAN',
		name: 'IBAN',
		placeholder: '...',
		type: 'text',
		rules: 'required|valid_iban',
		depends: function(field) {
			return document.getElementById('bankTransfer').checked ? true : false;
		},
		className: 'hidden-xs-up Input--bankTransfer'
	},
	{
		label: 'SWIFT',
		display: 'SWIFT',
		id: 'SWIFT',
		name: 'SWIFT',
		placeholder: '...',
		type: 'text',
		rules: 'required|valid_swift',
		depends: function(field) {
			return document.getElementById('bankTransfer').checked ? true : false;
		},
		className: 'hidden-xs-up Input--bankTransfer'
	},
    {
        label: 'Copy details from previous step',
        display: 'Same Address',
        id: 'same_address',
        name: 'same_address',
        placeholder: '',
        type: 'checkbox',
        rules: 'allow_empty',
		depends: function(field) {
			return document.getElementById('bankTransfer').checked ? true : false;
		},
		className: 'hidden-xs-up Input--bankTransfer Input--sameAddress'
    },
	{
		label: 'Full name',
		display: 'Full name',
		id: 'name_alternative',
		name: 'name_alternative',
		placeholder: '...',
		type: 'text',
		rules: 'required|max_length[128]',
		depends: function(field) {
			return document.getElementById('bankTransfer').checked ? true : false;
		},
		className: 'hidden-xs-up Input--bankTransfer'
	},
	{
		label: 'Address (line 1)',
		display: 'Address (line 1)',
		id: 'address1_alternative',
		name: 'address1_alternative',
		placeholder: '...',
		type: 'text',
		rules: 'required|max_length[128]',
		depends: function(field) {
			return document.getElementById('bankTransfer').checked ? true : false;
		},
		className: 'hidden-xs-up Input--bankTransfer'
	},
	{
		label: 'Address (line 2)',
		display: 'Address (line 2)',
		id: 'address2_alternative',
		name: 'address2_alternative',
		placeholder: '...',
		type: 'text',
		rules: 'max_length[128]',
		depends: function(field) {
			return document.getElementById('bankTransfer').checked ? true : false;
		},
		className: 'hidden-xs-up Input--bankTransfer'
	},
	{
		label: 'City',
		display: 'City',
		id: 'city_alternative',
		name: 'city_alternative',
		placeholder: '...',
		type: 'text',
		rules: 'required|max_length[128]',
		depends: function(field) {
			return document.getElementById('bankTransfer').checked ? true : false;
		},
		className: 'hidden-xs-up Input--bankTransfer'
	},
	{
		label: 'ZIP code',
		display: 'ZIP code',
		id: 'zip_alternative',
		name: 'zip_alternative',
		placeholder: '12344',
		type: 'text',
		rules: 'required',
		depends: function(field) {
			return document.getElementById('bankTransfer').checked ? true : false;
		},
		className: 'hidden-xs-up Input--bankTransfer'
	},
	{
		label: 'Country',
		display: 'Country',
		id: 'country_alternative',
		name: 'country_alternative',
		placeholder: 'select country',
		type: 'select',
		rules: 'required',
		values: countries.countries,
		depends: function(field) {
			return document.getElementById('bankTransfer').checked ? true : false;
		},
		className: 'hidden-xs-up Input--bankTransfer'
	}
];

export default stepFields;



/** WEBPACK FOOTER **
 ** ./src/stores/Step3.js
 **/